export var ANIMATED_STATIC_COIN_ARTBOARD = 'coin_navbar_highlight';